import { Outlet, Link } from 'react-router-dom';

export function Layout() {
  return (
    <div style={{ minHeight: '100vh' }}>
      <header style={{ 
        background: 'var(--surface)', 
        borderBottom: '1px solid var(--border)',
        padding: '1rem 0',
        position: 'sticky',
        top: 0,
        zIndex: 50,
      }}>
        <div className="container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Link to="/" style={{ 
            fontSize: '1.5rem', 
            fontWeight: '800', 
            color: 'var(--primary)',
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
          }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="2" width="20" height="20" rx="2"/>
              <path d="M12 22V12M5 12l7-7 7 7"/>
            </svg>
            FFID Unban
          </Link>
          <nav style={{ display: 'flex', gap: '1rem' }}>
            <Link to="/admin/login" className="btn btn-secondary" style={{ padding: '0.5rem 1rem' }}>
              Admin
            </Link>
          </nav>
        </div>
      </header>
      <main>
        <Outlet />
      </main>
      <footer style={{ 
        background: 'var(--surface)', 
        borderTop: '1px solid var(--border)',
        padding: '1.5rem 0',
        marginTop: 'auto',
      }}>
        <div className="container" style={{ textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.875rem' }}>
          FFID Unban - Submit your screenshot for review
        </div>
      </footer>
    </div>
  );
}